import { __rest } from "tslib";
import { createElement } from 'rax';
import Children from 'rax-children';
import { default as Context } from './context';
export default (_a) => {
    var { children } = _a, others = __rest(_a, ["children"]);
    return (<Context.Provider value={others}>{Children.only(children)}</Context.Provider>);
};
